// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Bottom Bar (Full Width, 20% Height) */
.bottom-bar {
  width: 100%;
  height: 20vh;
  background-color: white;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid black;
  border-left: 1px solid black;
  border-right: 1px solid black;
  overflow: hidden;
  box-sizing: border-box;
  position: relative;
}

/* Wrapper for Labels & Temperature Lines */
.bottom-bar__wrapper {
  display: flex;
  width: 100%;
  height: 85%;
  position: relative;
  box-sizing: border-box;
}

/* Wrapper for all logos */
.bottom-bar__logos {
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  top: 1rem;
  display: flex;
  flex-direction: row;
  /* vedľa seba */
  justify-content: center;
  /* centrovanie horizontálne */
  align-items: center;
  /* centrovanie vertikálne */
  gap: 2rem;
  /* medzera medzi logami */
  padding: 10px;
  z-index: 5;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 0 5px 0 0;
  box-sizing: border-box;
}

/* Jednotlivé logá */
.bottom-bar__logo {
  height: 2.5rem;
  width: auto;
  max-width: 7rem;
  /* maximálna šírka */
  object-fit: contain;
  opacity: 0.9;
  transition: opacity 0.3s ease;
}

.bottom-bar__logo:hover {
  opacity: 1;
}

/* Left column: two logos stacked vertically */
.bottom-bar__logos-left {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

/* Right column: one logo centered */
.bottom-bar__logos-right {
  display: flex;
  align-items: center;
}


/* Labels (25% Left Side) */
.bottom-bar__labels {
  width: 25%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: flex-end;
  text-align: right;
  font-size: 0.7rem;
  font-weight: normal;
  padding-right: 10px;
  box-sizing: border-box;
}

.bottom-bar__label {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  position: relative;
  z-index: 10; /* základný */
}

.info-icon-wrapper {
  position: relative;
  z-index: 25; /* vyšší než logá */
}



/* Temperature Lines (75% Right Side) */
.bottom-bar__lines {
  width: 75%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  position: relative;
  box-sizing: border-box;
}

/* Individual Temperature Line */
.bottom-bar__line {
  display: flex;
  height: 20px;
  width: 100%;
  position: relative;
  box-sizing: border-box;
}

/* Each day in temperature line */
.bottom-bar__day {
  flex: 1 1;
  background-color: #ddd;
  border-right: 1px solid white;
  height: 100%;
  box-sizing: border-box;
}

.bottom-bar__day.green {
  background-color: #4caf50;
}

.bottom-bar__day.red {
  background-color: rgb(219, 24, 24);
  opacity: 0.5;
}

.bottom-bar__day.grey {
  background-color: #ddd;
}

.bottom-bar__day:last-child {
  border-right: none;
}

/* Footer Wrapper for Months */
.bottom-bar__footer {
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  height: 15%;
  box-sizing: border-box;
}

/* Months Row */
.bottom-bar__months {
  display: flex;
  justify-content: space-between;
  border-top: 2px solid black;
  background-color: #f9f9f9;
  font-size: 0.8rem;
  padding: 5px 0;
  width: 75%;
  margin-left: 25%;
  position: relative;
  box-sizing: border-box;
}

/* Each Month Label */
.bottom-bar__month {
  flex: 1 1;
  text-align: center;
  position: relative;
  box-sizing: border-box;
}

/* Month dividers */
.bottom-bar__month:before {
  content: "";
  position: absolute;
  left: 0;
  top: -500px;
  height: 1000px;
  width: 1px;
  background-color: black;
  z-index: 1;
}

/* Media Query for Medium Screens */
@media screen and (max-width: 1160px) {
  .bottom-bar__labels {
    width: 25% !important;
  }

  .bottom-bar__lines {
    width: 75% !important;
  }

  .bottom-bar__months {
    width: 75% !important;
    margin-left: 25% !important;
  }

  .bottom-bar__logo {
    height: 2rem;
    max-width: 6rem;
  }

  .bottom-bar__logos {
    gap: 1.5rem;
  }
}

/* Media Query for Small Screens */
@media screen and (max-width: 768px) {
  .bottom-bar__logo {
    height: 1.5rem;
    max-width: 5rem;
  }

  .bottom-bar__logos {
    gap: 1rem;
    padding: 5px;
  }
}

/* Extra large screens */
@media screen and (min-width: 1600px) {
  .bottom-bar__logo {
    height: 4rem;
    max-width: 12rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/bottom_bar.css"],"names":[],"mappings":"AAAA,wCAAwC;AACxC;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,4BAA4B;EAC5B,6BAA6B;EAC7B,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,yBAAyB;EACzB,aAAa;EACb,UAAU;EACV,0CAA0C;EAC1C,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;AACrB;;;AAGA,2BAA2B;AAC3B;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,WAAW,EAAE,aAAa;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW,EAAE,mBAAmB;AAClC;;;;AAIA,uCAAuC;AACvC;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,iCAAiC;AACjC;EACE,SAAO;EACP,sBAAsB;EACtB,6BAA6B;EAC7B,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,2BAA2B;EAC3B,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,SAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,cAAc;EACd,UAAU;EACV,uBAAuB;EACvB,UAAU;AACZ;;AAEA,mCAAmC;AACnC;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,YAAY;EACd;AACF;;AAEA,wBAAwB;AACxB;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF","sourcesContent":["/* Bottom Bar (Full Width, 20% Height) */\n.bottom-bar {\n  width: 100%;\n  height: 20vh;\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n  border-bottom: 1px solid black;\n  border-left: 1px solid black;\n  border-right: 1px solid black;\n  overflow: hidden;\n  box-sizing: border-box;\n  position: relative;\n}\n\n/* Wrapper for Labels & Temperature Lines */\n.bottom-bar__wrapper {\n  display: flex;\n  width: 100%;\n  height: 85%;\n  position: relative;\n  box-sizing: border-box;\n}\n\n/* Wrapper for all logos */\n.bottom-bar__logos {\n  position: absolute;\n  bottom: 1rem;\n  left: 1rem;\n  top: 1rem;\n  display: flex;\n  flex-direction: row;\n  /* vedľa seba */\n  justify-content: center;\n  /* centrovanie horizontálne */\n  align-items: center;\n  /* centrovanie vertikálne */\n  gap: 2rem;\n  /* medzera medzi logami */\n  padding: 10px;\n  z-index: 5;\n  background-color: rgba(255, 255, 255, 0.9);\n  border-radius: 0 5px 0 0;\n  box-sizing: border-box;\n}\n\n/* Jednotlivé logá */\n.bottom-bar__logo {\n  height: 2.5rem;\n  width: auto;\n  max-width: 7rem;\n  /* maximálna šírka */\n  object-fit: contain;\n  opacity: 0.9;\n  transition: opacity 0.3s ease;\n}\n\n.bottom-bar__logo:hover {\n  opacity: 1;\n}\n\n/* Left column: two logos stacked vertically */\n.bottom-bar__logos-left {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n/* Right column: one logo centered */\n.bottom-bar__logos-right {\n  display: flex;\n  align-items: center;\n}\n\n\n/* Labels (25% Left Side) */\n.bottom-bar__labels {\n  width: 25%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  align-items: flex-end;\n  text-align: right;\n  font-size: 0.7rem;\n  font-weight: normal;\n  padding-right: 10px;\n  box-sizing: border-box;\n}\n\n.bottom-bar__label {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n  position: relative;\n  z-index: 10; /* základný */\n}\n\n.info-icon-wrapper {\n  position: relative;\n  z-index: 25; /* vyšší než logá */\n}\n\n\n\n/* Temperature Lines (75% Right Side) */\n.bottom-bar__lines {\n  width: 75%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  position: relative;\n  box-sizing: border-box;\n}\n\n/* Individual Temperature Line */\n.bottom-bar__line {\n  display: flex;\n  height: 20px;\n  width: 100%;\n  position: relative;\n  box-sizing: border-box;\n}\n\n/* Each day in temperature line */\n.bottom-bar__day {\n  flex: 1;\n  background-color: #ddd;\n  border-right: 1px solid white;\n  height: 100%;\n  box-sizing: border-box;\n}\n\n.bottom-bar__day.green {\n  background-color: #4caf50;\n}\n\n.bottom-bar__day.red {\n  background-color: rgb(219, 24, 24);\n  opacity: 0.5;\n}\n\n.bottom-bar__day.grey {\n  background-color: #ddd;\n}\n\n.bottom-bar__day:last-child {\n  border-right: none;\n}\n\n/* Footer Wrapper for Months */\n.bottom-bar__footer {\n  display: flex;\n  align-items: center;\n  position: relative;\n  width: 100%;\n  height: 15%;\n  box-sizing: border-box;\n}\n\n/* Months Row */\n.bottom-bar__months {\n  display: flex;\n  justify-content: space-between;\n  border-top: 2px solid black;\n  background-color: #f9f9f9;\n  font-size: 0.8rem;\n  padding: 5px 0;\n  width: 75%;\n  margin-left: 25%;\n  position: relative;\n  box-sizing: border-box;\n}\n\n/* Each Month Label */\n.bottom-bar__month {\n  flex: 1;\n  text-align: center;\n  position: relative;\n  box-sizing: border-box;\n}\n\n/* Month dividers */\n.bottom-bar__month:before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: -500px;\n  height: 1000px;\n  width: 1px;\n  background-color: black;\n  z-index: 1;\n}\n\n/* Media Query for Medium Screens */\n@media screen and (max-width: 1160px) {\n  .bottom-bar__labels {\n    width: 25% !important;\n  }\n\n  .bottom-bar__lines {\n    width: 75% !important;\n  }\n\n  .bottom-bar__months {\n    width: 75% !important;\n    margin-left: 25% !important;\n  }\n\n  .bottom-bar__logo {\n    height: 2rem;\n    max-width: 6rem;\n  }\n\n  .bottom-bar__logos {\n    gap: 1.5rem;\n  }\n}\n\n/* Media Query for Small Screens */\n@media screen and (max-width: 768px) {\n  .bottom-bar__logo {\n    height: 1.5rem;\n    max-width: 5rem;\n  }\n\n  .bottom-bar__logos {\n    gap: 1rem;\n    padding: 5px;\n  }\n}\n\n/* Extra large screens */\n@media screen and (min-width: 1600px) {\n  .bottom-bar__logo {\n    height: 4rem;\n    max-width: 12rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
